// ABOUTME: Skeleton placeholder shaped like a square pack list row — shown while packs are loading.
// ABOUTME: Mirrors the ListItem row layout to prevent layout shift.
import ListItem from '@mui/material/ListItem'
import Skeleton from '@mui/material/Skeleton'

export function SquarePackRowSkeleton() {
  return (
    <ListItem data-testid="square-pack-row-skeleton">
      <Skeleton variant="text" width="70%" />
    </ListItem>
  )
}
